module.exports = __webpack_public_path__ + "static/media/The Outlet LA NFT how to vid.eb2b9c93.mp4";